<script setup>
import Default from '@/Layouts/Default.vue';
import ProviderHeader from '@/Components/Content/Header/Provider.vue';
import Content from '@/Components/Content/index.vue';
import AccordianGroup from '@/Components/Accordion/Group.vue';
import AccordianItem from '@/Components/Accordion/Item.vue';
import Heading from '@/Components/Heading.vue';
import { Head, usePage } from '@inertiajs/vue3';
import { AUSTRALIA_COUNTRY_NAME } from '@/constants';
import { computed } from 'vue';

const props = defineProps({
  provider: {
    type: Object,
    required: true,
  }
});

const page = usePage();
const context = computed(() => page.props?.context);
const providerName = context.value.name;

const sitesOrderedByScopedState = computed(() => {
  const sites = props.provider.sites;

  if (context.value?.search_filters?.all_scoped_states) {
    sites.sort((a, b) => {
      const aIsPriority = context.value.search_filters.all_scoped_states.includes(a.state);
      const bIsPriority = context.value.search_filters.all_scoped_states.includes(b.state);
      if (aIsPriority === bIsPriority) return 0;
      return aIsPriority ? -1 : 1;
    });
  }

  return sites;
});
</script>


<template>
  <Head>
    <title>{{props.provider.name}} - {{ providerName }}</title>
    <meta name="description" :content="props.provider.description">
  </Head>
  <Default>
    <Content>
      <template #header>
        <ProviderHeader :provider="provider" />
      </template>
      <template #content>
        <Heading
          size="h2"
          style-size="h2"
          class="mb-2"
        >
          About the provider
        </Heading>
        <p class="mb-2">
          <strong>Type of provider:</strong> {{ provider.simple_organisation_type }}
        </p>
        <p>{{ provider.description }}</p>
        <AccordianGroup>
          <AccordianItem :is-open="true">
            <template #title>
              Locations
            </template>
            <template #content>
              <div
                v-for="site, index in sitesOrderedByScopedState"
                :key="`course-site-${index}`"
              >
                <p class="mb-1 mt-3">
                  <strong>Address</strong>
                </p>
                <p>{{ site.name }}</p>
                <p>{{ site.street1 }}</p>
                <p>{{ [site.suburb, site.state_name_full, site.postcode].filter((v) => !!v).join(', ') }}</p>
                <p v-if="site.country.name !== AUSTRALIA_COUNTRY_NAME">{{ site.country.name }}</p>
                <hr class="w-full my-6">
              </div>
            </template>
          </AccordianItem>
        </AccordianGroup>
      </template>
    </Content>
  </Default>
</template>
